import { useSelector, RootStateOrAny } from 'react-redux';
import { AuthState } from 'store/ducks/auth';

export const usePermissions = () => {
  const { data: userData, loggedIn } = useSelector<RootStateOrAny>(
    (state) => state?.auth
  ) as AuthState;
  return {
    hasAnyPermission(permissions: string[] = []) {
      if (!loggedIn) return false;
      return permissions.some((p) => userData?.roles.includes(p));
    },
    hasEveryPermission(permissions: string[] = []) {
      if (!loggedIn) return false;
      return permissions.every((p) => userData?.roles.includes(p));
    },

    checkUserPermission(acceptedPermission: string) {
      if (!loggedIn || !userData) return false;
      if (!acceptedPermission) return false;

      if (acceptedPermission.includes('all')) return true;

      const { permissions, country, is_super_adm } = userData;

      if (is_super_adm) return true;
      if (!permissions) return false;
      if (!country) return false;

      // Encontra as permissões correspondentes com base no slug (acceptedPermission)
      const findPermissions = permissions.find(
        (permission) => permission.slug === acceptedPermission
      );

      // Verifica se encontou alguma permissão e se o país está incluído no array de países permitidos
      const checkCountry = findPermissions?.countries.includes(country.id);

      // Retorna verdadeiro se as permissões forem encontradas e o país estiver permitido
      if (findPermissions && checkCountry) return true;

      return false;
    },

    checkUserEveryPermission(acceptedPermissions: string[]) {
      if (!loggedIn || !userData) return false;

      if (acceptedPermissions.includes('all')) return true;

      const { permissions, country } = userData;

      if (!permissions) return false;
      if (!country) return false;

      // Verifica se todas as permissões são encontradas e se o país está incluído no array de países permitidos para cada permissão
      for (const acceptedPermission of acceptedPermissions) {
        const findPermission = permissions.find(
          (permission) => permission.slug === acceptedPermission
        );

        if (!findPermission || !findPermission.countries.includes(country.id)) {
          return false;
        }
      }

      return true;
    },
  };
};
